/* eslint-disable react/no-array-index-key */
// CompanyLogos.js
import React from 'react';
import styled from 'styled-components';
import {
  GoogleLogo,
  MetaLogo,
  NvidiaLogo,
  PfizerLogo,
  TeslaLogo,
} from './logoSvgs';
import breakpointsMinWidth from '../../../../../../cra/src/styling/breakpointsMinWidth';

const Wrapper = styled.section`
  background-color: ${({ bgColor }) => bgColor || '#f8f6ff'};
  padding: 26px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media ${breakpointsMinWidth.desktopSm} {
    padding: 33px 20px;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    padding: 60px 20px;
  }
`;

const Title = styled.p`
  font-size: 14px;
  font-weight: 500;
  color: #222;
  margin-bottom: 24px;
  text-align: center;

  @media ${breakpointsMinWidth.desktopSm} {
    font-size: 16px;
  }
`;

const LogosRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: center;
  align-items: center;

  @media ${breakpointsMinWidth.tabletSm} {
    gap: 40px;
  }
  @media ${breakpointsMinWidth.tabletLg} {
    gap: 77px;
  }
  @media ${breakpointsMinWidth.desktopSm} {
    gap: 48px;
  }
`;

const LogoItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LogoSVG = styled.div`
  width: 100%;
  height: 100%;

  svg {
    height: 20px;
    width: auto;

    @media ${breakpointsMinWidth.tabletSm} {
      height: 32px;
    }
    @media ${breakpointsMinWidth.desktopSm} {
      height: 40px;
    }
  }
`;

const CompanyLogos = ({ bgColor }) => {
  const logos = [NvidiaLogo, GoogleLogo, TeslaLogo, MetaLogo, PfizerLogo]; // dummy list, all using same SVG
  return (
    <Wrapper bgColor={bgColor}>
      <Title>Wisedoc users have been hired by</Title>
      <LogosRow>
        {logos.map((Logo, index) => (
          <LogoItem key={index}>
            <LogoSVG>
              <Logo />
            </LogoSVG>
          </LogoItem>
        ))}
      </LogosRow>
    </Wrapper>
  );
};

export default CompanyLogos;
